import React from 'react'
import UserStoryFormInput from '../../input-components/testcase-generation/UserStoryFormInput'
import { Box, Button, Container } from "@mui/material";

const TestCasesInputPage = () => {
  return (

   
    <div>
        <UserStoryFormInput />
    </div>
 
  )
}

export default TestCasesInputPage